export default "__VITE_ASSET__66e68265__"